<template>
  <b-container class="external">
    <router-view />
  </b-container>
</template>

<script>
import Vue from "vue";
import LogoFull from "../../components/LogoFull.vue";

Vue.component("logoFull", LogoFull);

export default {
  name: "External"
};
</script>

<style></style>
